export default __webpack_public_path__ + "static/media/up-icon.eb7802a2.svg";